import { useParams } from "react-router-dom";
import { MapPin, Phone, Instagram } from "lucide-react";

const PAGES = {
  sobre: {
    title: "Sobre a Nalin",
    content: (
      <>
        <p>A Nalin Atacado & Varejo é uma loja de moda em Magé - RJ, com anos de tradição atendendo clientes com variedade, estilo e preço acessível.</p>
        <p>Trabalhamos com peças femininas, masculinas, infantis e acessórios, sempre atentos às tendências e ao conforto de quem veste.</p>
      </>
    ),
  },
  loja: {
    title: "Nossa loja",
    content: (
      <>
        <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#C91F1F]" /> Rua Dr. Siqueira, nº 269, Magé - RJ</p>
        <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#C91F1F]" /> +55 21 98495-3716</p>
        <p className="flex items-center gap-2"><Instagram className="h-4 w-4 text-[#C91F1F]" /> @nalinatacado</p>
      </>
    ),
  },
  contato: { title: "Contato", content: <p>Fale conosco pelo WhatsApp <a className="text-[#C91F1F] font-semibold" href="https://wa.me/5521984953716">+55 21 98495-3716</a> ou pelo Instagram <a className="text-[#C91F1F] font-semibold" href="https://instagram.com/nalinatacado">@nalinatacado</a>.</p> },
  privacidade: { title: "Política de Privacidade", content: <p>Respeitamos a sua privacidade. Utilizamos seus dados apenas para viabilizar a compra e o atendimento, em conformidade com a LGPD. Você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento pelo nosso canal de atendimento.</p> },
  termos: { title: "Termos de Uso", content: <p>Ao utilizar o site da Nalin, você concorda em fornecer informações verídicas para efetivação da compra e retirada. Os preços e disponibilidade estão sujeitos a alterações sem aviso prévio.</p> },
  trocas: { title: "Política de Trocas e Devoluções", content: <p>Peças podem ser trocadas em até 7 dias após a retirada, mediante apresentação do comprovante e nas condições originais. Produtos com defeito de fabricação seguem os prazos previstos pelo CDC.</p> },
  retirada: { title: "Política de Retirada", content: <p>Após a confirmação do pagamento, seu pedido será separado. Você receberá um aviso quando estiver pronto para retirada na loja Magé-RJ. Traga um documento com foto.</p> },
  faq: { title: "FAQ", content: (
    <div className="space-y-4">
      <div><strong>Como funciona a retirada?</strong><p className="text-neutral-600 text-sm">Aguarde a confirmação de que o pedido está pronto, então venha à nossa loja em Magé-RJ com um documento com foto.</p></div>
      <div><strong>Quais formas de pagamento aceitam?</strong><p className="text-neutral-600 text-sm">Pix e cartão de crédito (com parcelamento em até 3x sem juros).</p></div>
      <div><strong>Vocês entregam?</strong><p className="text-neutral-600 text-sm">Nesta versão, atendemos apenas com retirada na loja física.</p></div>
    </div>
  ) },
};

export default function Institutional() {
  const { page } = useParams();
  const data = PAGES[page] || { title: "Página", content: <p>Conteúdo em breve.</p> };
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 sm:py-14">
      <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: "Outfit" }}>{data.title}</h1>
      <div className="prose prose-neutral space-y-4 text-neutral-700">{data.content}</div>
    </div>
  );
}
